import { cva } from 'class-variance-authority';

export const skeletonVariants = cva(
  // Base styles with dark mode support
  ['bg-gray-200', 'dark:bg-slate-700'],
  {
    variants: {
      variant: {
        text: ['rounded'],
        circular: ['rounded-full'],
        rectangular: ['rounded-lg'],
      },
      animation: {
        pulse: ['animate-pulse'],
        shimmer: [
          'relative',
          'overflow-hidden',
          'before:absolute',
          'before:inset-0',
          'before:-translate-x-full',
          'before:animate-shimmer',
          'before:bg-gradient-to-r',
          'before:from-transparent',
          // Light mode: white shimmer, Dark mode: subtle slate shimmer
          'before:via-white/40',
          'dark:before:via-slate-600/40',
          'before:to-transparent',
        ],
        none: [],
      },
    },
    defaultVariants: {
      variant: 'text',
      animation: 'pulse',
    },
  }
);
